import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarEmpty } from '@fortawesome/free-regular-svg-icons';

export const formatPrice = (price) => {
  return Number(price || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' SEK';
};
export const parseUtcDate = (dateString) => {
  if (!dateString) return null;
  const normalized = dateString
    .replace(' ', 'T')
    .replace(/([^Z+-])([+-]\d{2}:\d{2})?$/ , (match, p1, p2) => {
      return p2 ? match : p1 + 'Z';
    });
  const date = new Date(normalized);
  return isNaN(date.getTime()) ? null : date;
};

export const getRelativeTime = (dateString) => {
  if (!dateString) return '';

  const date = parseUtcDate(dateString);
  if (!date) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();


  if (diffMs < 0) return 'just now';

  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = parseUtcDate(dateString);
  if (!date) return '';

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
};
export const renderStars = (rating) => {
  const stars = [];
  const value = Number(rating || 0);
  const full = Math.floor(value);
  const half = value % 1 >= 0.5;

  for (let i = 0; i < full; i++) {
    stars.push(<FontAwesomeIcon key={`f${i}`} icon={faStar} />);
  }

  if (half) {
    stars.push(<FontAwesomeIcon key="h" icon={faStarHalfAlt} />);
  }

  for (let i = 0; i < 5 - full - (half ? 1 : 0); i++) {
    stars.push(<FontAwesomeIcon key={`e${i}`} icon={faStarEmpty} />);
  }

  return stars;
};
